import { render, staticRenderFns } from "./ECommerceAnalysisApplicationDetail.vue?vue&type=template&id=008b88fc&scoped=true&"
import script from "./ECommerceAnalysisApplicationDetail.vue?vue&type=script&lang=js&"
export * from "./ECommerceAnalysisApplicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceAnalysisApplicationDetail.vue?vue&type=style&index=0&id=008b88fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b88fc",
  null
  
)

export default component.exports